import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SystemIcon } from '@monorepo/nova-icons';
import { Box, Button, Typography } from '@monorepo/nova-ui';

interface MidnightErrorStateProps {
  error: Error | string | unknown;
  onRetry: () => void;
}

export const MidnightErrorState: FC<MidnightErrorStateProps> = ({
  error,
  onRetry,
}) => {
  const { t } = useTranslation(['common', 'dashboardHeader']);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight={200}
      gap={2}
    >
      <SystemIcon iconName="WarningCircle" size={48} color="error" />
      <Typography variant="h6" color="error" align="center">
        {t('common:error.default')}
      </Typography>
      <Typography variant="body2" align="center">
        {error instanceof Error ? error.message : String(error)}
      </Typography>
      <Button variant="outlined" onClick={onRetry}>
        {t('dashboardHeader:programSelector.retry')}
      </Button>
    </Box>
  );
};
